'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        $field = context.find('[data-binding="countdownfield"]');

    function init() {

        $field.each(function () {
            var $this = $(this),
                maxChars = parseInt($this.attr('data-charlimit'));

            $this.after('<p class="char-count"><span data-binding="chars">' + maxChars + '</span> characters remaining</p>');

            $this.keyup(function () {
                var characterCounter = context.find('[data-binding="chars"]'),
                    length = $(this).val().length,
                    remainingChars = maxChars - length;

                characterCounter.text(remainingChars);
            });
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/character-count.js
// module id = 265
// module chunks = 0